import { BANK_CODES } from '@js/constants/banks';
import { reduce } from '@/components/Form/javascripts/codes';

import GROUPS from './javascripts/groups';

const REPEATING_RULES = {
  ALWAYS_VISIBLE: reduce(BANK_CODES, [
    [{ rule: 'required' }],
  ]),
};

export default {
  vehicles: {
    group: null,
    label: GROUPS.MAIN.title,
    description: GROUPS.MAIN.subtitle,

    fields: {
      store_id: {
        group: null,
        label: 'Loja',
        description: 'Selecione',
        validations: [{
          type: 'blank',
        }],
        rules: {},
      },

      q: {
        group: null,
        label: 'Buscar',
        description: 'Pesquisar veículo...',
        validations: [],
        rules: REPEATING_RULES.ALWAYS_VISIBLE,
        type: 'search',
      },
      sort: {
        group: null,
        label: 'Ordenação',
        description: 'Selecione',
        validations: [{
          type: 'blank',
        }],
        options: [{
          value: 'public_price_asc',
          label: 'Menores preços',
        }, {
          value: 'public_price_desc',
          label: 'Maiores preços',
        }],
        rules: REPEATING_RULES.ALWAYS_VISIBLE,
      },

      vehicle_brand_id: {
        group: null,
        label: 'Marca do veículo',
        description: 'Selecione',
        domain: 'vehicle_brand',
        validations: [],
        rules: REPEATING_RULES.ALWAYS_VISIBLE,
      },
      vehicle_type_id: {
        group: null,
        label: 'Tipo do veículo',
        description: 'Selecione',
        domain: 'vehicle_type',
        validations: [],
        rules: REPEATING_RULES.ALWAYS_VISIBLE,
      },
      zero_km: {
        group: null,
        label: 'Novos ou usados?',
        description: 'Selecione',
        validations: [],
        type: 'select',
        options: [{
          value: 'true',
          label: 'Veículos novos',
        }, {
          value: 'false',
          label: 'Veículos usados',
        }],
        rules: REPEATING_RULES.ALWAYS_VISIBLE,
      },
    },
  },
};
